import { Divider, Fade, Grid, Hidden, Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/styles'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { fetchBookingInfo } from '../../actions/bookingInfo'
import { setStepFilter } from '../../actions/filter'
//import { setLanguageFilter } from '../../actions/filter'
import { fetchLanguage } from '../../actions/language'
import getLangcodeFromUrl from '../../helpers/getLangcodeFromUrl'
import {
  AverageConfirmedBooking,
  AverageDelegateCount,
  AverageLeadTime,
  BookingSources,
  CancelBookingReasons,
  ConfirmedBookingValue,
  //EventHeld,
  DayRangeFilter,
  DayRangeFilterMobile,
  FutureOverallStatus,
  LatestOrders,
  //NumberOfBookingsChart,
  MajorMeasurement,
  //LatestProducts,
  //LatestSales,
  //SuccessBookingRate,
  RevenueEarned,
  //CancelBooking,
  //DurationDropdown,
  //AverageCount,
  UnconfirmedBookingValue,
  VenuesDropdown
} from './components'
import getWindowVenues from '../../helpers/getWindowVenues'
import { withRouter } from 'react-router'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  title: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2)
  }
}))

const Dashboard = withRouter(
  ({
    location,
    fetchBookingInfo,
    futureBookings,
    selectedDuration, // setLanguageFilter
    fetchLanguage,
    from,
    to,
    step,
    setStepFilter
  }) => {
    const classes = useStyles()
    // const bookingInfoActions = useActions(BookingInfoActions)

    //const isLoading = useSelector(state => state.bookingInfo.isLoading)
    const selectedVenue = useSelector(state => state.filter.selectedVenue)
    // useEffect(() => {
    //   bookingInfoActions.fetchBookingInfo()
    // }, [bookingInfoActions])

    useEffect(() => {
      if (step === 2) {
        if (selectedVenue) {
          fetchBookingInfo(
            selectedVenue,
            format(from, 'yyyy-MM-dd'),
            format(to, 'yyyy-MM-dd')
          )
          setStepFilter(0)
        }
      }
    }, [fetchBookingInfo, setStepFilter, step, from, to, selectedVenue])

    useEffect(() => {
      fetchLanguage(
        getLangcodeFromUrl(location.pathname),
        'dashboard',
        'bookameeting'
      )
      // setLanguageFilter(match.params.langcode)
    }, [fetchLanguage, location.pathname])

    const windowVenues = getWindowVenues()

    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV === 'production') {
      if (windowVenues.length === 0) {
        return (
          <div className={classes.root}>
            <Grid container justify="center" spacing={4}>
              <Grid item lg={6} xs={12}>
                <div className={classes.content}>
                  <Typography variant="h1">Ooopppps</Typography>
                  <Typography variant="subtitle2">
                    You do not have an active venue. Please add a venue in order
                    to see this page!!!
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </div>
        )
      }
    }

    return (
      <Fade in>
        <div className={classes.root}>
          <Grid container spacing={4} justify="flex-start">
            <Grid item lg={3} sm={12} md={3} xl={3} xs={12}>
              <VenuesDropdown></VenuesDropdown>
            </Grid>
            {/* <Hidden only={['xs', 'md', 'lg', 'xl']}>
          <Grid item sm={6}></Grid>
        </Hidden> */}
            <Hidden smDown>
              <DayRangeFilter></DayRangeFilter>
            </Hidden>
            <Hidden mdUp>
              <DayRangeFilterMobile></DayRangeFilterMobile>
            </Hidden>

            {/* <Grid item lg={3} sm={12} md={3} xl={3} xs={12}>
          <DurationDropdown></DurationDropdown>
        </Grid> */}
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Divider varient="middle" style={{}}></Divider>
            </Grid>
          </Grid>

          <>
            {futureBookings ? (
              <Typography variant="h4" className={classes.title}>
                {futureBookings}
              </Typography>
            ) : (
              <>
                <Skeleton width="20%" className={classes.title} height="20px" />
              </>
            )}

            <Grid container spacing={4} justify="flex-start">
              <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                <FutureOverallStatus />
              </Grid>

              <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                <Grid container spacing={4} justify="flex-start">
                  <Grid
                    item
                    // xl={6} lg={6} sm={6}
                    xs={12}>
                    <ConfirmedBookingValue></ConfirmedBookingValue>
                  </Grid>
                  <Grid
                    item
                    // xl={6} lg={6} sm={6}
                    xs={12}>
                    <UnconfirmedBookingValue></UnconfirmedBookingValue>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {selectedDuration ? (
              <Typography variant="h4" className={classes.title}>
                {selectedDuration}
              </Typography>
            ) : (
              <Skeleton width="20%" className={classes.title} height="20px" />
            )}

            <Grid container spacing={4} justify="flex-start">
              {/* <Grid item xl={3} lg={3} sm={6} xs={12}>
              <EventHeld />
            </Grid>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <TotalBookings />
            </Grid>
            <Grid item xl={3} lg={3} sm={6} xs={12}>
              <SuccessBookingRate />
            </Grid> */}

              <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                <AverageDelegateCount></AverageDelegateCount>
              </Grid>

              <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                <AverageLeadTime></AverageLeadTime>
              </Grid>

              <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                <AverageConfirmedBooking></AverageConfirmedBooking>
              </Grid>

              <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                <RevenueEarned />
              </Grid>
              {/* <Grid item xl={3} lg={4} md={6} xs={12}>
              <OverallStatus />
            </Grid> */}

              <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Grid item xs={12}>
                  <BookingSources></BookingSources>
                </Grid>
              </Grid>

              {/* <Grid item lg={8} md={12} xl={9} xs={12}>
<LatestSales />
</Grid> */}

              <Grid item xl={3} lg={6} sm={6} xs={12}>
                <Grid container spacing={4} justify="flex-start">
                  <Grid item xs={12}>
                    <MajorMeasurement></MajorMeasurement>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xl={3} lg={6} sm={6} xs={12}>
                <Grid container spacing={4} justify="flex-start">
                  <Grid item xs={12}>
                    <CancelBookingReasons></CancelBookingReasons>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid item xl={3} lg={4} sm={6} xs={12}>
              <AverageCount></AverageCount>
            </Grid> */}

              <Grid item xl={9} xs={12}>
                <LatestOrders />
              </Grid>

              {/* <Grid item lg={4} md={6} xl={3} xs={12}>
<LatestProducts />
</Grid> */}
              {/* <Grid item lg={8} md={12} xl={9} xs={12}>
<LatestOrders />
</Grid> */}
            </Grid>
          </>
        </div>
      </Fade>
    )
  }
)

Dashboard.propTypes = {
  fetchBookingInfo: PropTypes.func,

  futureBookings: PropTypes.string,
  selectedDuration: PropTypes.string,
  match: PropTypes.object,
  //setLanguageFilter: PropTypes.func,
  fetchLanguage: PropTypes.func,
  from: PropTypes.object,
  to: PropTypes.object,
  step: PropTypes.number,
  setStepFilter: PropTypes.func
}

const mapStateToProps = state => ({
  selectedDuration: state.language.text.selectedDuration,
  futureBookings: state.language.text.futureBookings,
  from: state.filter.from,
  to: state.filter.to,
  step: state.filter.step
})

export default connect(mapStateToProps, {
  fetchBookingInfo,
  // setLanguageFilter,
  fetchLanguage,
  setStepFilter
})(Dashboard)
